import { apiClient } from '@/lib/api-client'
import { currentLocale } from '@/lib/i18n'

/**
 * Download the visible terms of a collection as a spreadsheet.
 *
 * A POST rather than a link because the server needs the ids of what is
 * actually on screen — the filtering and ordering happen in the client, and
 * re-deriving them server-side would be a second implementation free to drift.
 * That costs the blob dance below, which is the price of the export matching
 * what the curator was looking at.
 */
export async function exportCollectionTerms(
  collectionId: number,
  termIds: number[],
): Promise<void> {
  const res = await apiClient.post(
    `/collections/${collectionId}/terms.xlsx`,
    { term_ids: termIds, lang: currentLocale() },
    { responseType: 'blob' },
  )

  // The server names the file (it knows the collection name, and encodes it
  // per RFC 5987); fall back only if the header is missing.
  const disposition = String(res.headers['content-disposition'] ?? '')
  const utf8 = /filename\*=UTF-8''([^;]+)/i.exec(disposition)?.[1]
  const plain = /filename="([^"]+)"/i.exec(disposition)?.[1]
  const filename = utf8 ? decodeURIComponent(utf8) : (plain ?? 'terms.xlsx')

  const url = URL.createObjectURL(res.data as Blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  a.remove()
  // Revoking immediately can cancel the download in some browsers.
  setTimeout(() => URL.revokeObjectURL(url), 1000)
}
